// ─── User Roles ─────────────────────────────────────────────────────────────
export const ROLES = {
  PUBLIC: 'public',
  CONTRIBUTOR: 'contributor',
  SITE_OWNER: 'site_owner',
  ADMIN: 'admin',
};

// Role hierarchy: higher index = more permissions
export const ROLE_HIERARCHY = [
  ROLES.PUBLIC,
  ROLES.CONTRIBUTOR,
  ROLES.SITE_OWNER,
  ROLES.ADMIN,
];

/**
 * Returns true if `userRole` has at least the access level of `requiredRole`.
 */
export function hasRole(userRole, requiredRole) {
  return ROLE_HIERARCHY.indexOf(userRole) >= ROLE_HIERARCHY.indexOf(requiredRole);
}

// ─── Map Settings ────────────────────────────────────────────────────────────
export const MAP_DEFAULTS = {
  center: [20, 15],       // roughly centered on Africa / Middle East
  zoom: 2.5,
  minZoom: 1,
  maxZoom: 18,
  style: 'mapbox://styles/mapbox/dark-v11',
  // Zoom threshold below which we switch from heatmap → individual pins
  PIN_ZOOM_THRESHOLD: 6,
};

// Heatmap colour ramp (low density → high density)
export const HEATMAP_COLOR_RAMP = [
  'interpolate',
  ['linear'],
  ['heatmap-density'],
  0,   'rgba(0,0,255,0)',
  0.2, 'rgb(0,140,255)',
  0.4, 'rgb(0,255,200)',
  0.6, 'rgb(255,220,0)',
  0.8, 'rgb(255,120,0)',
  1,   'rgb(255,40,40)',
];

// ─── Date Range ───────────────────────────────────────────────────────────────
export const DEFAULT_DATE_RANGE = {
  start: '2020-01-01',
  end:   new Date().toISOString().slice(0, 10),
};

// ─── Stripe ───────────────────────────────────────────────────────────────────
export const DONATION_PRESETS = [10, 25, 50, 100, 250];
export const CURRENCY = 'usd';

// ─── Pagination ───────────────────────────────────────────────────────────────
export const STORIES_PAGE_SIZE = 10;
